export default "__VITE_ASSET__vtfsRH6I__"